module.exports = fox._r("fonts/icon-mc_other2.svg?ctdsoz", __webpack_public_path__ + "_/_/_/common/frame/fonts/icon-mc_other2.svg");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/fonts/icon-mc_other2.svg?ctdsoz
// module id = 150
// module chunks = 2